var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { ETypeOfContact, } from "@domains/salesFeatures/Common/entities/iFilterTypeOfContactEntity";
import { leadStatusConfig } from "@frameworks/salesjourney/utils/commonLeadStatusConfig";
import { EdelAbortSignals } from "@domains/salesFeatures/Common/utils/commonMethod";
var FilterDataPresenter = /** @class */ (function () {
    function FilterDataPresenter(useCases, actions) {
        var _this = this;
        this.useCases = useCases;
        this.actions = actions;
        this.getSubSourceDataForMultipleSources = function (req) {
            return new Promise(function (resolve, reject) {
                var sourceId = req.sourceId;
                var apiPromise = null;
                if ([
                    leadStatusConfig.employeeSourceId,
                    leadStatusConfig.clientSourceId,
                    leadStatusConfig.dsaSourceId,
                ].includes(sourceId)) {
                    apiPromise = _this.getDSAClientEmployee({
                        page: req === null || req === void 0 ? void 0 : req.page,
                        pageSize: req === null || req === void 0 ? void 0 : req.pageSize,
                        sourceId: sourceId,
                    });
                }
                else {
                    apiPromise = _this.getSubSourceData({
                        page: req === null || req === void 0 ? void 0 : req.page,
                        pageSize: req === null || req === void 0 ? void 0 : req.pageSize,
                        sourceId: sourceId,
                    }).then(function (subSourcedata) {
                        return subSourcedata.subSourcesList;
                    });
                }
                if (apiPromise) {
                    apiPromise
                        .then(function (data) {
                        var subSourcedata = __spreadArray([], __read(data), false);
                        resolve({ filterData: subSourcedata });
                    })
                        .catch(function (error) {
                        console.error("Error:", error);
                        reject(error);
                    });
                }
                else {
                    resolve({ filterData: [] });
                }
            });
        };
        this.abortControllers = new EdelAbortSignals({
            getDisplaySchemeData: new AbortController(),
        });
    }
    FilterDataPresenter.prototype.getEntityTypeData = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.useCases.entityTypeUseCase.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    FilterDataPresenter.prototype.getPreferencesData = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.useCases.preferencesDataUseCase.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, null);
        });
    };
    FilterDataPresenter.prototype.getDisplaySchemeData = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.useCases.displaySchemeNameUseCase.execute({
                onSuccess: function (data) {
                    resolve(data);
                    //this.actions?.filterDataActions.updateFilterData(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, __assign(__assign({}, req), { abortSignal: _this.abortControllers.abortSignal("getDisplaySchemeData") }));
        });
    };
    FilterDataPresenter.prototype.getPartnersListOfLoggedInFRM = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.useCases.frmPartnerList.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    FilterDataPresenter.prototype.getRegistrationData = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.useCases.registrationBucketUseCase.execute({
                onSuccess: function (data) {
                    resolve(data);
                    //this.actions?.filterDataActions.updateFilterData(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    FilterDataPresenter.prototype.getPotentialTierData = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.useCases.potentialTierDataUseCase.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    FilterDataPresenter.prototype.getSubCatByScheme = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.useCases.SubCategoryByScheme.execute({
                onSuccess: function (data) {
                    resolve(data);
                    //this.actions?.filterDataActions.updateFilterData(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    FilterDataPresenter.prototype.getSchemeByCategory = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.useCases.SchemeByCategory.execute({
                onSuccess: function (data) {
                    resolve(data);
                    //this.actions?.filterDataActions.updateFilterData(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    FilterDataPresenter.prototype.getSubCategoryAll = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.useCases.SubCategoryAll.execute({
                onSuccess: function (data) {
                    resolve(data);
                    //this.actions?.filterDataActions.updateFilterData(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    FilterDataPresenter.prototype.getDSAClientEmployee = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.useCases.dsaClientEmployee.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    FilterDataPresenter.prototype.getLeadStatus = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.useCases.leadStatusData.execute({
                onSuccess: function (data) {
                    resolve(data);
                    //this.actions?.filterDataActions.updateFilterData(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    FilterDataPresenter.prototype.getSubStatusData = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.useCases.subStatusData.execute({
                onSuccess: function (data) {
                    resolve(data);
                    //this.actions?.filterDataActions.updateFilterData(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    FilterDataPresenter.prototype.getStatusData = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.useCases.statusData.execute({
                onSuccess: function (data) {
                    resolve(data);
                    //this.actions?.filterDataActions.updateFilterData(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    FilterDataPresenter.prototype.getSubSourceData = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.useCases.subSourcesData.execute({
                onSuccess: function (data) {
                    resolve(data);
                    //this.actions?.filterDataActions.updateFilterData(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    FilterDataPresenter.prototype.getSourceData = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.useCases.sourceData.execute({
                onSuccess: function (data) {
                    resolve(data);
                    //this.actions?.filterDataActions.updateFilterData(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    FilterDataPresenter.prototype.getFilterCustomerType = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.useCases.filterCustomerTypeData.execute({
                onSuccess: function (data) {
                    resolve(data);
                    //this.actions?.filterDataActions.updateFilterData(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    FilterDataPresenter.prototype.getFilterTypeOfContact = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.useCases.filterTypeOfContactData.execute({
                onSuccess: function (data) {
                    data.filterData = data.filterData.map(function (x) {
                        return {
                            id: x.id,
                            name: ETypeOfContact[x.name],
                        };
                    });
                    resolve(data);
                    //this.actions?.filterDataActions.updateFilterData(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    FilterDataPresenter.prototype.getBucketDataActions = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.useCases.bucketData.execute({
                onSuccess: function (data) {
                    resolve(data);
                    //this.actions?.filterDataActions.updateFilterData(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    FilterDataPresenter.prototype.getCategoryDataActions = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.useCases.categoryData.execute({
                onSuccess: function (data) {
                    resolve(data);
                    //this.actions?.filterDataActions.updateFilterData(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    FilterDataPresenter.prototype.getSubCategoryData = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.useCases.subCategoryData.execute({
                onSuccess: function (data) {
                    resolve(data);
                    //this.actions?.filterDataActions.updateFilterData(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    FilterDataPresenter.prototype.getMastersData = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var salesProduct, externalParticipantsPromise, participantsPromise, bucketPromise, interactionPromise, sourcePromise, typeOfContactPromise, _a, interaction, bucket, sourceData, 
            // statusEntity,
            typeOfContact, participants, externalParticipants;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        salesProduct = {
                            interaction: {},
                            bucket: {},
                            sourceData: {},
                            // statusEntity: {} as IStatusEntity,
                            typeOfContact: {},
                            participants: {},
                            externalParticipants: {},
                        };
                        externalParticipantsPromise = new Promise(function (resolve, reject) {
                            _this.useCases.extPartfilterData.execute({
                                onSuccess: function (data) {
                                    resolve(data);
                                    //this.actions?.filterDataActions.updateFilterData(data);
                                },
                                onError: function (error) {
                                    reject(error);
                                },
                            }, req);
                        });
                        participantsPromise = new Promise(function (resolve, reject) {
                            _this.useCases.participantsfilterData.execute({
                                onSuccess: function (data) {
                                    resolve(data);
                                    //this.actions?.filterDataActions.updateFilterData(data);
                                },
                                onError: function (error) {
                                    reject(error);
                                },
                            }, req);
                        });
                        bucketPromise = new Promise(function (resolve, reject) {
                            _this.useCases.bucketData.execute({
                                onSuccess: function (data) {
                                    resolve(data);
                                    //this.actions?.filterDataActions.updateFilterData(data);
                                },
                                onError: function (error) {
                                    reject(error);
                                },
                            }, req);
                        });
                        interactionPromise = new Promise(function (resolve, reject) {
                            _this.useCases.interactionStatus.execute({
                                onSuccess: function (data) {
                                    resolve(data);
                                },
                                onError: function (error) {
                                    reject(error);
                                },
                            }, req);
                        });
                        sourcePromise = new Promise(function (resolve, reject) {
                            _this.useCases.sourceData.execute({
                                onSuccess: function (data) {
                                    resolve(data);
                                    //this.actions?.filterDataActions.updateFilterData(data);
                                },
                                onError: function (error) {
                                    reject(error);
                                },
                            }, req);
                        });
                        typeOfContactPromise = new Promise(function (resolve, reject) {
                            _this.useCases.filterTypeOfContactData.execute({
                                onSuccess: function (data) {
                                    data.typeOfContacts = data.typeOfContacts.map(function (x) {
                                        return {
                                            id: x.id,
                                            name: ETypeOfContact[x.name],
                                        };
                                    });
                                    resolve(data);
                                    //this.actions?.filterDataActions.updateFilterData(data);
                                },
                                onError: function (error) {
                                    reject(error);
                                },
                            }, req);
                        });
                        return [4 /*yield*/, Promise.all([
                                interactionPromise,
                                bucketPromise,
                                sourcePromise,
                                // statusPromise,
                                typeOfContactPromise,
                                participantsPromise,
                                externalParticipantsPromise,
                            ])];
                    case 1:
                        _a = __read.apply(void 0, [_b.sent(), 6]), interaction = _a[0], bucket = _a[1], sourceData = _a[2], typeOfContact = _a[3], participants = _a[4], externalParticipants = _a[5];
                        salesProduct.interaction = interaction;
                        salesProduct.bucket = bucket;
                        salesProduct.sourceData = sourceData;
                        //salesProduct.statusEntity = statusEntity;
                        salesProduct.typeOfContact = typeOfContact;
                        salesProduct.participants = participants;
                        salesProduct.externalParticipants = externalParticipants;
                        return [2 /*return*/, salesProduct];
                }
            });
        });
    };
    FilterDataPresenter.prototype.getProductDataActions = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.useCases.productData.execute({
                onSuccess: function (data) {
                    resolve(data);
                    //this.actions?.filterDataActions.updateFilterData(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    FilterDataPresenter.prototype.updateFinalFilterState = function (finalFilterState) {
        this.actions.filterDataActions.updateFinalFilterState(finalFilterState);
    };
    FilterDataPresenter.prototype.updateNRProductList = function (nrProductList) {
        this.actions.filterDataActions.updateNRProductList(nrProductList);
    };
    FilterDataPresenter.prototype.getInteractionStatusData = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.useCases.interactionStatus.execute({
                            onSuccess: function (data) {
                                resolve(data);
                            },
                            onError: function (error) {
                                reject(error);
                            },
                        }, req);
                    })];
            });
        });
    };
    FilterDataPresenter.prototype.getFilterDataActions = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.useCases.filterData.execute({
                onSuccess: function (data) {
                    resolve(data);
                    //this.actions?.filterDataActions.updateFilterData(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    FilterDataPresenter.prototype.getTierData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.useCases.tierUseCase.execute({
                            onSuccess: function (data) {
                                resolve(data);
                            },
                            onError: function (error) {
                                reject(error);
                            },
                        }, null);
                    })];
            });
        });
    };
    FilterDataPresenter.prototype.getSchemeFilterDataActions = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.useCases.schemefilterData.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    FilterDataPresenter.prototype.getExtPartFilterDataActions = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.useCases.extPartfilterData.execute({
                            onSuccess: function (data) {
                                resolve(data);
                            },
                            onError: function (error) {
                                reject(error);
                            },
                        }, req);
                    })];
            });
        });
    };
    FilterDataPresenter.prototype.getParticipantsFilterDataActions = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.useCases.participantsfilterData.execute({
                            onSuccess: function (data) {
                                resolve(data);
                            },
                            onError: function (error) {
                                reject(error);
                            },
                        }, req);
                    })];
            });
        });
    };
    FilterDataPresenter.prototype.getStandardResponseActions = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.useCases.stnrespfilterData.execute({
                            onSuccess: function (data) {
                                resolve(data);
                                //this.actions?.filterDataActions.updateFilterData(data);
                            },
                            onError: function (error) {
                                reject(error);
                            },
                        }, req);
                    })];
            });
        });
    };
    FilterDataPresenter.prototype.validateFocus = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.useCases.validateFocus.execute({
                            onSuccess: function (data) {
                                resolve(data);
                            },
                            onError: function (error) {
                                reject(error);
                            },
                        }, req);
                    })];
            });
        });
    };
    return FilterDataPresenter;
}());
export default FilterDataPresenter;
